"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCars = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var filterSlice_1 = require("./filterSlice");
exports.loadCars = (0, toolkit_1.createAsyncThunk)('cars/loadCars', function (params, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, filterValues, queryParams, page, allParams, queryString, totalPagesUrl, totalPagesResponse, total_pages, carsUrl, carsResponse, cars, transformCarsBrand, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                state = thunkAPI.getState();
                filterValues = state.filter.values;
                queryParams = new URLSearchParams();
                page = (params === null || params === void 0 ? void 0 : params.page) || 1;
                queryParams.append('page', String(page));
                allParams = {};
                if (params) {
                    Object.entries(params).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        if (value && key !== 'page') {
                            allParams[key] = String(value);
                        }
                    });
                }
                Object.entries(filterValues).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    if (value && key in filterSlice_1.filterMapping) {
                        var apiKey = filterSlice_1.filterMapping[key];
                        if (!(apiKey in allParams)) {
                            allParams[apiKey] = value;
                        }
                    }
                });
                queryString = Object.entries(allParams)
                    .map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return "".concat(key, "=").concat(value);
                })
                    .join('&');
                totalPagesUrl = "".concat(process.env.REACT_APP_BASE_URL, "/cars/total_pages").concat(queryString ? "?".concat(queryString) : '');
                return [4 /*yield*/, fetch(totalPagesUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            case 1:
                totalPagesResponse = _a.sent();
                if (!totalPagesResponse.ok) {
                    throw new Error('Ошибка получения количества страниц');
                }
                return [4 /*yield*/, totalPagesResponse.json()];
            case 2:
                total_pages = (_a.sent()).total_pages;
                carsUrl = "".concat(process.env.REACT_APP_BASE_URL, "/cars").concat(queryString ? "?".concat(queryString, "&") : '?', "page=").concat(page);
                return [4 /*yield*/, fetch(carsUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            case 3:
                carsResponse = _a.sent();
                if (!carsResponse.ok) {
                    throw new Error('Ошибка получения списка машин');
                }
                return [4 /*yield*/, carsResponse.json()];
            case 4:
                cars = _a.sent();
                transformCarsBrand = cars.map(function (auto) {
                    return __assign(__assign({}, auto), { brand: auto.brand.name });
                });
                return [2 /*return*/, {
                        items: transformCarsBrand,
                        pagination: {
                            currentPage: page,
                            totalPages: total_pages,
                        },
                    }];
            case 5:
                error_1 = _a.sent();
                console.error('Load cars error:', error_1);
                return [2 /*return*/, thunkAPI.rejectWithValue('Ошибка загрузки автомобилей')];
            case 6: return [2 /*return*/];
        }
    });
}); });
var initialState = {
    carsList: [],
    isLoading: false,
    error: null,
    pagination: {
        currentPage: 1,
        totalPages: 1,
    },
};
var carsSlice = (0, toolkit_1.createSlice)({
    name: 'cars',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(exports.loadCars.pending, function (state) {
            state.isLoading = true;
            state.error = null;
        })
            .addCase(exports.loadCars.fulfilled, function (state, action) {
            state.isLoading = false;
            state.carsList = action.payload.items;
            state.pagination = action.payload.pagination;
        })
            .addCase(exports.loadCars.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});
exports.default = carsSlice.reducer;
